/**
 * 状态管理
 */

// 导航栏
export const ELMENU_SWITCH = 'ELMENU_SWITCH'
export const HEADERNAV_SWITCH = 'HEADERNAV_SWITCH'

// 登录
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_OUT_LOGIN = 'USER_OUT_LOGIN'

// 公共部分
export const COM_LOADING_STATUS = 'COM_LOADING_STATUS'

// news
export const GET_NEWS_LIST_SUCCESS = 'GET_NEWS_LIST_SUCCESS'
export const UPDATE_NEWS_DATA = 'UPDATE_NEWS_DATA'
export const UPDATE_NEWS_CONTENT = 'UPDATE_NEWS_CONTENT'
export const QUERY_NEWS_CONTENT = 'QUERY_NEWS_CONTENT'
export const ADD_NEWS_CONTENT = 'ADD_NEWS_CONTENT'
export const GET_NEWS_LABELS_SUCCESS = 'GET_NEWS_LABELS_SUCCESS'
export const ADD_NEWS_DATA_DONE = 'ADD_NEWS_DATA_DONE'
// press
export const GET_PRESS_LIST_SUCCESS = 'GET_PRESS_LIST_SUCCESS'
export const APPID_LOGIN_SUCCESS = 'APPID_LOGIN_SUCCESS'
// audit
export const GET_AUDIT_LIST_SUCCESS = 'GET_AUDIT_LIST_SUCCESS'
// stats
export const GET_CONSOLE_NEWS_LIST = 'GET_CONSOLE_NEWS_LIST'
export const GET_NEWS_STATIS_LIST = 'GET_NEWS_STATIS_LIST'
export const GET_CONSOLE_EVENT_LIST = 'GET_CONSOLE_EVENT_LIST'
export const GET_CONSOLE_API_LIST = 'GET_CONSOLE_API_LIST'
export const GET_LABELS_LIST = 'GET_LABELS_LIST'
export const ADD_CONSOLE_DATA_DONE = 'ADD_CONSOLE_DATA_DONE'
export const UPDATE_STATS_DATA = 'UPDATE_STATS_DATA'
export const GET_PUBLISHER_DATA = 'GET_PUBLISHER_DATA'



// WEBPACK FOOTER //
// ./src/store/mutation.js